import {
  PANEL_LICENSE_CTA_ACTIONS_TITLE,
  PANEL_LICENSE_CTA_BODY,
  PANEL_LICENSE_CTA_TITLE,
} from "@/modules/panelLicenseActivationCtas";
import PanelLicenseActivationCtaButtons from "@/components/PanelLicenseActivationCtaButtons";

/**
 * CTAs visibles en Panel General cuando trial/licencia requiere activación.
 */
export default function PanelLicenseActivationCtas({ systemInfo, showModuleCta = false }) {
  return (
    <section
      className="w-full min-w-0 rounded-sm border border-amber-300 bg-amber-50/80 px-4 py-4 space-y-3 sm:px-5"
      data-testid="panel-license-activation-ctas"
      aria-label="Activación de licencia"
    >
      <div>
        <h2 className="text-sm font-semibold text-amber-950 m-0">{PANEL_LICENSE_CTA_TITLE}</h2>
        <p className="text-xs text-amber-900/90 mt-1 mb-0 leading-relaxed">{PANEL_LICENSE_CTA_BODY}</p>
      </div>
      <div className="space-y-2">
        <h3 className="text-[11px] font-semibold uppercase tracking-wider text-amber-950/90 m-0">
          {PANEL_LICENSE_CTA_ACTIONS_TITLE}
        </h3>
        <PanelLicenseActivationCtaButtons systemInfo={systemInfo} showModuleCta={showModuleCta} />
      </div>
    </section>
  );
}
